import { render, staticRenderFns } from "./gCartInfoSection.vue?vue&type=template&id=10ffe4a6&scoped=true&"
import script from "./gCartInfoSection.vue?vue&type=script&lang=js&"
export * from "./gCartInfoSection.vue?vue&type=script&lang=js&"
import style0 from "./gCartInfoSection.vue?vue&type=style&index=0&id=10ffe4a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ffe4a6",
  null
  
)

export default component.exports